import { render, staticRenderFns } from "./EditCreate.vue?vue&type=template&id=62830ca2&scoped=true"
import script from "./EditCreate.vue?vue&type=script&lang=js"
export * from "./EditCreate.vue?vue&type=script&lang=js"
import style0 from "./EditCreate.vue?vue&type=style&index=0&id=62830ca2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62830ca2",
  null
  
)

export default component.exports